"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIProxy = void 0;
const apollo_client_1 = require("apollo-client");
const auth_1 = require("../auth");
const mutations_1 = require("../mutations");
const queries_1 = require("../queries");
const utils_1 = require("../utils");
class APIProxy {
    constructor(client) {
        this.getAttributes = this.watchQuery(queries_1.QUERIES.Attributes, data => data.attributes);
        this.getProductDetails = this.watchQuery(queries_1.QUERIES.ProductDetails, data => data.product);
        this.getProductList = this.watchQuery(queries_1.QUERIES.ProductList, data => data.products);
        this.getCategoryDetails = this.watchQuery(queries_1.QUERIES.CategoryDetails, data => data.category);
        this.getOrdersByUser = this.watchQuery(queries_1.QUERIES.OrdersByUser, data => data.me ? data.me.orders : null);
        this.getOrderDetails = this.watchQuery(queries_1.QUERIES.OrderDetails, data => data.orderByToken);
        this.getVariantsProducts = this.watchQuery(queries_1.QUERIES.VariantsProducts, data => data.productVariants);
        this.getShopDetails = this.watchQuery(queries_1.QUERIES.GetShopDetails, data => data);
        this.setUserDefaultAddress = this.fireQuery(mutations_1.MUTATIONS.AddressTypeUpdate, data => data.accountSetDefaultAddress);
        this.setDeleteUserAddress = this.fireQuery(mutations_1.MUTATIONS.DeleteUserAddress, data => data.accountAddressDelete);
        this.setCreateUserAddress = this.fireQuery(mutations_1.MUTATIONS.CreateUserAddress, data => data.accountAddressCreate);
        this.setUpdateuserAddress = this.fireQuery(mutations_1.MUTATIONS.UpdateUserAddress, data => data.accountAddressUpdate);
        this.setAccountUpdate = this.fireQuery(mutations_1.MUTATIONS.AccountUpdate, data => data.accountUpdate);
        this.setPasswordChange = this.fireQuery(mutations_1.MUTATIONS.PasswordChange, data => data);
        this.setPassword = this.fireQuery(mutations_1.MUTATIONS.SetPassword, data => data);
        this.getUserDetails = (variables, options) => {
            if (this.isLoggedIn()) {
                return this.watchQuery(queries_1.QUERIES.UserDetails, data => data.me)(variables, options);
            }
            if (options.onUpdate) {
                options.onUpdate(null);
            }
            return {
                refetch: () => new Promise((resolve, _reject) => {
                    resolve({ data: null });
                }),
                unsubscribe: () => undefined,
            };
        };
        this.signIn = (variables, options) => new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                this.client.resetStore();
                const data = yield this.fireQuery(mutations_1.MUTATIONS.TokenAuth, data => data.tokenCreate)(variables, Object.assign(Object.assign({}, options), { update: (proxy, data) => {
                        const handledData = handleDataErrors((data) => data.tokenCreate, data.data, data.errors);
                        if (!handledData.errors && handledData.data) {
                            auth_1.setAuthToken(handledData.data.token);
                            if (window.PasswordCredential && variables) {
                                navigator.credentials.store(new window.PasswordCredential({
                                    id: variables.email,
                                    password: variables.password,
                                }));
                            }
                        }
                        if (options && options.update) {
                            options.update(proxy, data);
                        }
                    } }));
                resolve(data);
            }
            catch (e) {
                reject(e);
            }
        }));
        this.signOut = () => new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                auth_1.fireSignOut(this.client);
                resolve();
            }
            catch (e) {
                reject(e);
            }
        }));
        this.attachAuthListener = (callback) => {
            const eventHandler = () => {
                callback(this.isLoggedIn());
            };
            addEventListener("auth", eventHandler);
            return () => {
                removeEventListener("auth", eventHandler);
            };
        };
        this.isLoggedIn = () => {
            return !!auth_1.getAuthToken();
        };
        this.client = client;
    }
    watchQuery(query, mapFn) {
        return (variables, options) => {
            const { onComplete, onError, onUpdate } = options, apolloClientOptions = __rest(options, ["onComplete", "onError", "onUpdate"]);
            const observable = query(this.client, Object.assign(Object.assign({}, apolloClientOptions), { variables }));
            if (options.skip) {
                return {
                    refetch: (_variables) => {
                        return new Promise((resolve, _reject) => {
                            resolve({ data: null });
                        });
                    },
                    unsubscribe: null,
                };
            }
            const subscription = observable.subscribe(result => {
                const { data, errors: apolloErrors } = result;
                const errorHandledData = handleDataErrors(mapFn, data, apolloErrors);
                if (onUpdate) {
                    if (errorHandledData.errors) {
                        if (onError) {
                            onError(errorHandledData.errors);
                        }
                    }
                    else {
                        onUpdate(errorHandledData.data);
                        if (onComplete) {
                            onComplete();
                        }
                    }
                }
            }, error => {
                if (onError) {
                    onError(error);
                }
            });
            return {
                loadMore: (extraVariables, mergeResults = true) => {
                    observable.fetchMore({
                        updateQuery: (previousResult, { fetchMoreResult }) => {
                            if (!fetchMoreResult) {
                                // returning previousResult doesn't trigger observable `next`
                                onUpdate(mapFn(previousResult));
                                return previousResult;
                            }
                            if (mergeResults) {
                                const prevResultRef = mapFn(previousResult);
                                const newResultRef = mapFn(fetchMoreResult);
                                if (!prevResultRef || !newResultRef) {
                                    onUpdate(prevResultRef);
                                    return previousResult;
                                }
                                const mergedEdges = utils_1.mergeEdges(prevResultRef.edges, newResultRef.edges);
                                // use new result for metadata and mutate existing data
                                Object.keys(prevResultRef).forEach(key => {
                                    prevResultRef[key] = newResultRef[key];
                                });
                                prevResultRef.edges = mergedEdges;
                                return previousResult;
                            }
                            return fetchMoreResult;
                        },
                        variables: Object.assign(Object.assign({}, variables), extraVariables),
                    });
                },
                refetch: (variables) => {
                    if (variables) {
                        observable.setVariables(variables);
                        const cachedResult = observable.currentResult();
                        const errorHandledData = handleDataErrors(mapFn, cachedResult.data);
                        if (errorHandledData.data) {
                            onUpdate(errorHandledData.data);
                        }
                    }
                    return this.firePromise(() => observable.refetch(variables), mapFn);
                },
                setOptions: (options) => this.firePromise(() => observable.setOptions(options), mapFn),
                unsubscribe: subscription.unsubscribe.bind(subscription),
            };
        };
    }
    fireQuery(query, mapFn) {
        return (variables, options) => this.firePromise(() => query(this.client, Object.assign(Object.assign({}, options), { variables })), mapFn);
    }
    // Promise wrapper to catch errors
    firePromise(promise, mapFn) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const { data, errors: apolloErrors } = yield promise();
                const errorHandledData = handleDataErrors(mapFn, data, apolloErrors);
                if (errorHandledData.errors) {
                    reject(errorHandledData.errors);
                }
                resolve({ data: errorHandledData.data });
            }
            catch (error) {
                reject(error);
            }
        }));
    }
}
exports.APIProxy = APIProxy;
// error handler
const handleDataErrors = (mapFn, data, apolloErrors) => {
    // INFO: user input errors will be moved to graphql errors
    const userInputErrors = utils_1.getErrorsFromData(data);
    const errors = apolloErrors || userInputErrors
        ? new apollo_client_1.ApolloError({
            extraInfo: userInputErrors,
            graphQLErrors: apolloErrors,
        })
        : null;
    if (errors && utils_1.isDataEmpty(data)) {
        return { errors };
    }
    const result = utils_1.getMappedData(mapFn, data);
    return { data: result };
};
//# sourceMappingURL=APIProxy.js.map